import { LineItemSelector } from '@reveni-io/reveni-ui'

import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import BlockedProductsPreviewSkeleton from './BlockedProductsPreviewSkeleton/BlockedProductsPreviewSkeleton'
import useBlockedProductsPreview from './hooks/useBlockedProductsPreview/useBlockedProductsPreview'
import * as Styles from './styles'

const BlockedProductsPreview = ({ activeBlockedProduct, customCopies, lang, merchantInfo }) => {
  const { lineItem, notReturnableReason, previewMerchantInfo, loading } = useBlockedProductsPreview({
    activeBlockedProduct,
    customCopies,
    lang,
    merchantInfo,
  })

  if (loading) return <BlockedProductsPreviewSkeleton />

  return (
    <Styles.Container>
      <WhiteLabelThemeProvider>
        <Styles.PreviewContent>
          <LineItemSelector
            lineItem={lineItem}
            isReturnable={false}
            notReturnableReason={notReturnableReason}
            merchantInfo={previewMerchantInfo}
            clickable={false}
            showToggle={false}
            showIndex={false}
            language={lang}
          />
        </Styles.PreviewContent>
      </WhiteLabelThemeProvider>
    </Styles.Container>
  )
}

export default BlockedProductsPreview
